import React from 'react'
import { browserHistory } from 'react-router'
import update from 'immutability-helper';

import NavLink from '../../Routes/NavLink'

import { sensors } from '../../../core/controllers/Sensors'
import { modal } from '../../../core/utilities/modal'
import { rentlyIntegrationController } from '../../../core/controllers/RentlyIntegrationController'

export default class Sensor extends React.Component {
    constructor(props) {
        super(props);
        // #  Need to make sure that we are not forcing other components that
        // want to use this functionality, to specify another component name
        // e.g. spaceDataID should be id so it is generic
        this.state = {
            minimized: false,
            spaceDetails: {
                taskTitle: (this.props.data.space_data.title || ""),
                spaceDataID: (this.props.data.space_data.space_data_id || 0),
                uuid: this.props.data.uuid
            },
            doorLock: {
                title: this.props.data.secondary_sensor_data ? this.props.data.secondary_sensor_data.sensor_name : null,
                uuid: this.props.data.secondary_sensor_data ? this.props.data.secondary_sensor_data.sensor_identifier : null,
            },
            sensorIdentifier: '',
            sensorType: (this.props.data.sensor_data.sensor_type || null),
            sensorActive: 0,
            getDataAgain: false,
            reloadData: false,
            sensorFriendlyValue: null,
            secondarySensorFriendlyValue: null
        }
        if(this.props.data.space_data.meta_data === undefined){
            this.state.lastUpdated = "";
        } else {
            this.state.lastUpdated = this.props.data.space_data.meta_data.last_updated;
            if(this.props.data.sensor_data) {
                this.state.sensorIdentifier   = this.props.data.sensor_data.sensor_identifier;
                this.state.sensorActive = this.props.data.sensor_data.active;
            }
        }

        this.interval = null;
    }

    componentDidMount() {
        // #  We need to setup our slimScroll on our editing window
		jQuery(jQuery('.single-task-card .scroll-attach')).slimScroll({
            height: '150px',
			alwaysVisible: true
        });

        this.interval = setInterval(() => this.checkCommunications(), 5000);
    }

    componentWillUnmount() {
        window.clearTimeout(this.interval);
    }

    componentWillUpdate(nextProps, nextState) {
        if(nextState.getDataAgain) {
            // get a reload of data
            this.reloadData(nextProps.data.uuid);
            nextState.getDataAgain = false;
        } else if (nextState.reloadData) {
            if(this.props.data.uuid !== nextProps.data.uuid) {
                nextState.reloadData = false;
                return;
            }
            nextState.reloadData = false;
        }
    }

    // #  minimizes SingleTask
    minimizeTask(e) {
        // #  update
        this.setState({
            minimized: true
        });
    }
    /**
    *
    * Maximizes SingleTask
    *
    */
    maximizeTask(e) {
        // #  update
        this.setState({
            minimized: false
        });
    }
    /**
    *
    * Updates title
    *
    */
    handleTitleChange(e) {
        this.setState({
            spaceDetails: update(this.state.spaceDetails, {
                taskTitle: {$set: e.target.value}
            })
        });
    }

    handleLockTitleChange(e) {
        this.setState({
            doorLock: update(this.state.doorLock, {
                title: {$set: e.target.value}
            })
        });
    }

    handleLockIdentifierChange(e) {
        this.setState({
            doorLock: update(this.state.doorLock, {
                uuid: {$set: e.target.value}
            })
        });
    }

    handleSensorUuidChange(e) {
        this.setState({
            sensorUuid: e.target.value
        });
    }

    sensorIdentifierChange(e) {
        this.setState({
            sensorIdentifier: e.target.value
        });
    }
    /**
    *
    * Saves space data
    *
    */
    handleSaveSpaceData(e) {
        sensors.saveSensorDetials(this);
    }
    /**
    *
    * Deletes space data
    *
    */
    handleDeleteSpaceData(e) {
        sensors.removeSpaceDetails(this);
    }

    disableAlarm(e) {
        sensors.disableAlarm(this);
    }
    /**
    *
    * Deletes space data and 3d build
    *
    */
    handleDeleteSpaceDataAndSpace(e) {
        sensors.removeSensorDetailsAnd3DBuild(this);
    }
    /**
     * Reloads task data.  Main use is for the graphical re-render of color states
     * @param {*} uuid 
     * @param {*} position 
     */
    reloadData(uuid) {
        sensors.getSensor(uuid, this);
    }

    checkCommunications() {
        if(this.state.sensorIdentifier) {
            sensors.getSensorCommunication(this.state.spaceDetails.uuid, this);
        }
    }

    triggerLock() {
        const sensor = {
            mode: 'lock',
            friendly_value: this.state.secondarySensorFriendlyValue,
            sensor_uuid: this.state.doorLock.uuid,
            friendly_name: this.state.doorLock.title,
            get_uuid: true
        };

        rentlyIntegrationController.triggerLock(sensor, function(response) {
            if(response.data.success) {
                var value = 'Unlocked';
                if(response.command == 'lock') {
                    value = 'Locked';
                }
                modal.showInfo(sensor.friendly_name + " was successfully " + value + '!', "success", "top", "center");
            } else {
                modal.showInfo(sensor.friendly_name + " failed to " + value + '!', "danger", "top", "center");
            }
        });
    }

    render(){
        const spaceDataID = this.state.spaceDetails.spaceDataID;
        const isMinimized = this.props.isMinimized;
        const sensorActive = this.state.sensorActive;
        const sensorFriendlyValue = this.state.sensorFriendlyValue;
        const secondarySensorFriendlyValue = this.state.secondarySensorFriendlyValue;
        const sensorType  = this.state.sensorType;
        var icon = 'icon-icons8-water';
        if(sensorType == 'doorsensor') {
            icon = 'icon-icons8-door-sensor-filled'
        } else if (sensorType == 'firealarm') {
            icon = 'icon-icons8-fire-alarm-box'
        } else if (sensorType == 'tempsensor') {
            icon = 'icon-icons8-thermometer-automation'
        }
        if(!isMinimized) {
            if(spaceDataID === undefined || spaceDataID == 0) {
                return (
                    <div class="card">
                        <div class="header">
                            <button type="button" aria-hidden="true" class="close" onClick={this.props.closeTask}>×</button>
                            <button type="button" aria-hidden="true" class="close minimize" onClick={this.props.minimizeTask}><i class="pe-7s-angle-down"></i></button>
                            <h4 class="title" onClick={this.props.minimizeTask}>Viewing Sensor</h4>
                            <p class="category"><i class={icon}></i></p>
                        </div>
                        <div class="content">
                            <div class="scroll-attach">
                                <div class="row">
                                    <div class="col-md-5">
                                        <div class="form-group">
                                            <label>Sensor Title</label>
                                            <input type="text" class="form-control" name="title" placeholder="Sensor Title" value={this.state.spaceDetails.taskTitle} id="title" onChange={this.handleTitleChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="footer">
                                <div class="legend">
                                    <button type="button" data-loading-text="Loading..." class="btn btn-danger btn-info btn-fill pull-right" autoComplete="off" onClick={this.handleDeleteSpaceDataAndSpace.bind(this)}>
                                    Delete
                                    </button>
                                    <button type="button" data-loading-text="Loading..." class="btn btn-primary btn-info btn-fill pull-right" autoComplete="off" onClick={this.handleSaveSpaceData.bind(this)}>
                                    Save
                                    </button>
                                    <div class="clearfix"></div>
                                </div>
                                <hr/>
                                <div class="stats">
                                </div>
                            </div>
                        </div>
                    </div>
                )
            } else {
                return (
                    <div class="card">
                        <div class="header">
                            <button type="button" aria-hidden="true" class="close" onClick={this.props.closeTask}>×</button>
                            <button type="button" aria-hidden="true" class="close minimize" onClick={this.props.minimizeTask}><i class="pe-7s-angle-down"></i></button>
                            <h4 class="title"onClick={this.props.minimizeTask}>Viewing Sensor: {this.state.spaceDetails.taskTitle}</h4>
                            <p class="category"><i class={icon}></i></p>
                        </div>
                        <div class="content">
                            <div class="scroll-attach">
                                <div class="row">
                                    <div class="col-md-5">
                                        <div class="form-group">
                                            <label>Sensor Title</label>
                                            <input type="text" class="form-control" name="title" placeholder="Sensor Title" value={this.state.spaceDetails.taskTitle} id="title" onChange={this.handleTitleChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-5">
                                        <div class="form-group">
                                            <label>Friendly Identifier</label>
                                            <input type="text" class="form-control" name="title" placeholder="Device Identifier" value={this.state.sensorIdentifier} id="sensoruuid" onChange={this.sensorIdentifierChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="clearfix"></div>
                                    <div class="header">
                                        <h5 class="title">Sensor Information <small>(refreshes every 5 seconds)</small></h5>
                                    </div>
                                    <div class="col-md-12">
                                    { sensorFriendlyValue != null ? (
                                        <div class="sensor-info">
                                            <h5 class="title status">
                                                <b><i class={icon}></i> {sensorFriendlyValue}</b>
                                            </h5>
                                        </div>
                                    ) : (
                                        <p>This will auto change when data is detected.</p>
                                    )}
                                    </div>
                                </div>
                                { sensorType === 'doorsensor' && (
                                    <div class="row">
                                        <div class="clearfix"></div>
                                        <div class="header">
                                            <h5 class="title">Door Lock</h5>
                                        </div>
                                        <div class="col-md-5">
                                            <div class="form-group">
                                                <label>Sensor Title</label>
                                                <input type="text" class="form-control" name="title" placeholder="Sensor Title" value={this.state.doorLock.title} id="title" onChange={this.handleLockTitleChange.bind(this)}/>
                                            </div>
                                        </div>
                                        <div class="col-md-5">
                                            <div class="form-group">
                                                <label>Lock Identifier</label>
                                                <input type="text" class="form-control" name="title" placeholder="Device Identifier" value={this.state.doorLock.uuid} id="sensoruuid" onChange={this.handleLockIdentifierChange.bind(this)}/>
                                            </div>
                                        </div>
                                        <div class="clearfix"></div>
                                        <div class="header">
                                            <h5 class="title">Lock Status <small>(refreshes every 5 seconds)</small></h5>
                                        </div>
                                        <div class="col-md-12">
                                        { secondarySensorFriendlyValue != null ? (
                                            <div>
                                            <div class="sensor-info">
                                                <h5 class="title status">
                                                    <b><i class="pe-7s-unlock"></i> {secondarySensorFriendlyValue}</b>
                                                </h5>
                                            </div>
                                            <button type="button" id="authenticate" data-loading-text="Loading..." class="btn btn-primary btn-warning btn-fill pull-left" autoComplete="off" onClick={this.triggerLock.bind(this)}>
                                            { secondarySensorFriendlyValue == 'unlocked' ? (
                                                <span>Lock Door</span>
                                            ) : (
                                                <span>Unlock Door</span>
                                            )}
                                            </button>
                                            </div>
                                        ) : (
                                            <p>This will auto change when data is detected.</p>
                                        )}
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div class="footer">
                                <div class="legend">
                                    <button type="button" data-loading-text="Loading..." class="btn btn-danger btn-info btn-fill pull-right" autoComplete="off" onClick={this.handleDeleteSpaceDataAndSpace.bind(this)}>
                                    Delete
                                    </button>
                                    <button type="button" data-loading-text="Loading..." class="btn btn-primary btn-info btn-fill pull-right" autoComplete="off" onClick={this.handleSaveSpaceData.bind(this)}>
                                    Update
                                    </button>
                                    <div class="clearfix"></div>
                                </div>
                                <hr/>
                                <div class="stats">
                                    <i class="fa fa-clock-o"></i> Last updated {this.state.lastUpdated}
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        } else {
            // # IS MINIMIZED
            if(spaceDataID === undefined || spaceDataID == 0) {
                return (
                    <div class="card">
                        <div class="header">
                            <button type="button" aria-hidden="true" class="close" onClick={this.props.closeTask}>×</button>
                            <button type="button" aria-hidden="true" class="close minimize" onClick={this.props.maximizeTask}><i class="pe-7s-angle-up"></i></button>
                            <h4 class="title" onClick={this.props.maximizeTask}>Viewing Sensor <i class={icon}></i></h4>
                            <p class="category"></p>
                        </div>
                    </div>
                );
            } else {
                return (
                    <div class="card">
                        <div class="header">
                            <button type="button" aria-hidden="true" class="close" onClick={this.props.closeTask}>×</button>
                            <button type="button" aria-hidden="true" class="close minimize" onClick={this.props.maximizeTask}><i class="pe-7s-angle-up"></i></button>
                            <h4 class="title" onClick={this.props.maximizeTask}>Sensor: {this.state.spaceDetails.taskTitle}  <i class={icon}></i></h4>
                            <p class="category"></p>
                        </div>
                    </div>
                );
            }
        }
    }
};


// WEBPACK FOOTER //
// app/components/MultiTaskManager/Type/Sensor.jsx